<!-- Aucnet Data Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Aucnet Data</h3>
    </div>

    <!-- Card Toolbar -->
    <div class="card-toolbar">
      <!-- Filter Button -->
      <div class="d-flex justify-content-end me-3">
        <button
          type="button"
          class="btn btn-sm btn-dark fw-bold d-flex"
          [class.active]="showFiltersForm"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Filter</span>
        </button>
      </div>


    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4 filter-section" *ngIf="showFiltersForm" [@slideInOut]>
    <!-- First Row -->
    <div class="row g-3 mb-4">
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Make</label>
        <app-searchable-select
          [options]="makesList"
          placeholder="All Makes"
          [(ngModel)]="filters.make"
          (selectionChange)="onMakeSelectionChange($event)"
          size="sm"
          [clearable]="true">
        </app-searchable-select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Model</label>
        <app-searchable-select
          [options]="modelsList"
          placeholder="All Models"
          [(ngModel)]="filters.model"
          size="sm"
          [clearable]="true"
          [disabled]="!filters.make">
        </app-searchable-select>
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Year From</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.year_from" placeholder="From" min="1990" max="2030">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Year To</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.year_to" placeholder="To" min="1990" max="2030">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Mileage From</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.mileage_from" placeholder="From KM">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Mileage To</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.mileage_to" placeholder="To KM">
      </div>
    </div>

    <!-- Second Row -->
    <div class="row g-3 mb-4">
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Keyword</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="searchTerm" placeholder="Search vehicles...">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Engine Size</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.engine_size" placeholder="e.g. 2000cc">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Price From (¥)</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.minimumPrice" placeholder="From">
      </div>
      <div class="col-md-2">
        <label class="form-label fw-semibold text-gray-600 fs-7">Price To (¥)</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.maximumPrice" placeholder="To">
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="filter-actions">
      <div class="d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-sm btn-light" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear Filters
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="d-flex align-items-center justify-content-center">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Loading vehicles...
      </div>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && vehicles.length === 0" class="text-center py-5">
      <div class="text-muted">No vehicles found</div>
    </div>

    <!-- Vehicles List -->
    <div *ngIf="!isLoading && vehicles.length > 0">
      <div *ngFor="let vehicle of vehicles; trackBy: trackByFn" class="card mb-4 border">
        <div class="card-body p-4">
          <div class="row align-items-center">
            <!-- Vehicle Image -->
            <div class="col-md-2">
              <div class="vehicle-image-container">
                <div class="vehicle-image" *ngIf="hasVehicleImage(vehicle)"
                     [style.background-image]="'url(' + getVehicleImageUrl(vehicle) + ')'"
                     style="width: 120px; height: 90px; background-size: cover; background-position: center; border-radius: 8px; border: 1px solid #e1e5e9;">
                </div>
                <div class="vehicle-image bg-light-primary d-flex align-items-center justify-content-center"
                     *ngIf="!hasVehicleImage(vehicle)"
                     style="width: 120px; height: 90px; border-radius: 8px; border: 1px solid #e1e5e9;">
                  <i class="ki-duotone ki-car fs-1 text-primary">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </i>
                </div>
              </div>
            </div>

            <!-- Vehicle Details -->
            <div class="col-md-7">
              <div class="row">
                <!-- Left Column -->
                <div class="col-md-6">
                  <div class="mb-2">
                    <span class="text-primary fw-bold fs-5" (click)="viewVehicle(vehicle)" style="cursor: pointer;">{{ vehicle.name || '-' }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">Stock Number:</span>
                    <span class="text-dark fs-7 fw-bold ms-2" (click)="viewVehicle(vehicle)" style="cursor: pointer;">{{ vehicle.inventory_no || '-' }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">Model Code:</span>
                    <span class="text-dark fs-7 fw-bold ms-2">{{ vehicle.vin_no || '-' }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">Transmission:</span>
                    <span class="text-dark fs-7 fw-bold ms-2">{{ vehicle.transmission || '-' }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">Data Source:</span>
                    <span class="badge badge-light-info ms-2">AUCNET</span>
                  </div>
                  <div class="mt-2">
                    <!-- Show action buttons if vehicle is not added to stock -->
                    <ng-container *ngIf="!vehicle.is_added_to_stock || !vehicle.vehicle_id">
                      <button
                        class="btn btn-sm btn-light-primary me-2"
                        (click)="addToRealStock(vehicle)"
                        [disabled]="isAddingToStock(vehicle._id)">
                        <span *ngIf="isAddingToStock(vehicle._id)" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {{ isAddingToStock(vehicle._id) ? 'Adding...' : 'Add To Real Stock' }}
                      </button>
                      <button class="btn btn-sm btn-light-info">Save as Dummy Stock</button>
                    </ng-container>

                    <!-- Show view stock link if vehicle is already added to stock -->
                    <ng-container *ngIf="vehicle.is_added_to_stock && vehicle.vehicle_id">
                      <a
                        [routerLink]="['/vehicles/vehicle-manager/edit', vehicle.vehicle_id]"
                        class="btn btn-sm btn-light-success">
                        <i class="ki-duotone ki-eye fs-6 me-1">
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                        </i>
                        View the Stock Here
                      </a>
                    </ng-container>
                  </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">Year/Month:</span>
                    <span class="text-dark fs-7 fw-bold ms-2">{{ vehicle.year || '-' }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">Mileage:</span>
                    <span class="text-dark fs-7 fw-bold ms-2">{{ vehicle.mileage ? (vehicle.mileage | number) + ' KM' : '-' }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">Engine:</span>
                    <span class="text-dark fs-7 fw-bold ms-2">{{ vehicle.engine || vehicle.fuel_type || '-' }}</span>
                  </div>
                  <div class="mb-1">
                    <span class="text-gray-600 fs-7 fw-semibold">M3 Size:</span>
                    <span class="text-dark fs-7 fw-bold ms-2">-</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Price Section -->
            <div class="col-md-3 text-end">
              <div class="mb-2 d-flex justify-content-end align-items-center">
                <!-- <span class="text-gray-600 fs-7 fw-semibold me-2">Grade:</span> -->
                <button
                  class="btn btn-icon btn-sm btn-light-primary"
                  (click)="openEditModal(vehicle)"
                  title="Edit Vehicle">
                  <i class="ki-duotone ki-pencil fs-4">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>
              </div>
              <div class="mb-1">
                <span class="text-gray-600 fs-7 fw-semibold">VIN Number:</span>
                <span class="text-dark fs-7 fw-bold ms-2">{{ vehicle.vin_no || vehicle.chassis_no || '-' }}</span>
              </div>
              <div class="mb-1">
                <span class="text-gray-600 fs-7 fw-semibold">Status:</span>
                <span class="badge badge-light-success ms-2">New On Sale</span>
              </div>
              <div class="mt-3">
                <div class="text-end">
                  <span class="text-gray-600 fs-8">Unit Price:</span>
                  <span class="text-primary fw-bold fs-6 d-block">{{ formatPrice(vehicle.price) }}</span>
                  <span class="text-gray-600 fs-8">+ Commission: 0 JP</span>
                  <span class="text-dark fw-bold fs-7 d-block">= Total Price: {{ formatPrice(vehicle.price) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && vehicles.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Update Car Modal -->
<app-update-car (carUpdated)="onCarUpdated()"></app-update-car>
